function PencilIcon() {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.99996 0.666687C4.39996 0.666687 0.666626 4.40002 0.666626 9.00002C0.666626 13.6 4.39996 17.3334 8.99996 17.3334C13.6 17.3334 17.3333 13.6 17.3333 9.00002C17.3333 4.40002 13.6 0.666687 8.99996 0.666687ZM6.91663 11.225V6.77502C6.91663 6.11669 7.64996 5.71669 8.19996 6.07502L11.6583 8.30002C12.1666 8.62502 12.1666 9.37502 11.6583 9.70002L8.19996 11.925C7.64996 12.2834 6.91663 11.8834 6.91663 11.225Z'
        fill='#FF5227'
      />
    </svg>
  );
}

export { PencilIcon };
